import { useRoutes } from 'react-router-dom';
import { CSAE, Landing, Privacy, TermsOfUse, TermsOfService } from 'features/misc';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/privacy', element: <Privacy /> },
    { path: '/terms-of-use', element: <TermsOfUse /> },
    { path: 'terms-of-service', element: <TermsOfService /> },
    { path: '/csae', element: <CSAE /> },
  ];
  const routes = publicRoutes;
  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
